@if (data$ | async; as componentData) {
  <header class="header pt-5 pb-5">
    <h1 class="header__title">{{ componentData | title }}</h1>

    <p-button
      (onClick)="menuButtonOverlay.toggle($event)"
      [text]="true"
      class="header__menu-trigger-button"
      icon="pi pi-ellipsis-v"
    />
  </header>

  <p-overlayPanel #menuButtonOverlay styleClass="header__menu-overlay">
    <p-button (onClick)="onCopyPageUrl()" [text]="true" class="header__menu-action-button" size="small">
      Copy Conversation Link
    </p-button>
    @if (componentData.hasTranscription) {
      <p-button (onClick)="onCopyTranscription()" [text]="true" class="header__menu-action-button" size="small">
        Copy Transcript
      </p-button>
    }
    @if (componentData.audio.data) {
      <p-button (onClick)="downloadCallAudio.emit()" [text]="true" class="header__menu-action-button" size="small">
        Download Call Audio
      </p-button>
    }
    @if (componentData.hasTranscription) {
      <p-button (onClick)="onDownloadConversationToPDF()" [text]="true" class="header__menu-action-button" size="small">
        Download Conversation to PDF
      </p-button>
    }
  </p-overlayPanel>
}

